import { ApiClientBase } from "api/ApiClientBase";

class TenantsApiClient extends ApiClientBase {
    listAvailableTenants() {
        return this.get(`/api/v1/tenants/available`);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new TenantsApiClient();
